<template>
	<div class="super_category_single_container">
	
		<contest-banner
		:contest="supercat_data"
		:label="supercat_data.category"
		:icon="supercat_data.icon"
		:lead_image="supercat_data.lead_image"
		:banner_type="contest_banner_type"
		:is_expanded="show_supercat_contests"
		@click.native="toggle_show_contests()"
		></contest-banner>

		<transition 
		name="" 
		enter-active-class="animated bounceInLeft faster" 
		leave-active-class="animated bounceOutRight faster"
		>

			<nomination-list-box
			v-show="show_supercat_contests"
			:contests="supercat_contests"
			:list_type="list_type"
			:supercat_icon="supercat_data.icon"
			></nomination-list-box>

		</transition>
	

	</div>
</template>

<script>
import ContestBanner from '@/features/contests/contest_banner.vue';
import NominationListBox from '@/features/nominate/nominate_list_box.vue';

export default {
	name: 'SuperCategorySingle',
	props: [
		'contests',
		'supercat_data',
		'list_type'
	],
	data () {
		return {
			contest_banner_type: 'supercat',
			supercat_contests: this.contests,
			show_supercat_contests: false
		}
	},
	mounted () {
		this.find_supercat_contests();
	},
	computed: {

	},
	methods: {
		find_supercat_contests() {
			this.supercat_contests = this.contests.filter((item) => {
				return item.category.match(this.supercat_data.category);
			})
		},
		toggle_show_contests() {
			this.show_supercat_contests = !this.show_supercat_contests;
		}
	},
	components: {
		ContestBanner,
		NominationListBox
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/features/category/super_category_single.vue